import type { AnimalSummary } from '@/api/hooks';

/** Animal disponível para entrar em um lote (ainda sem lote atual). */
export function animalIsAvailableForLot(animal: Pick<AnimalSummary, 'lot_id'>): boolean {
  return animal.lot_id == null;
}

/**
 * Ordena para seleção de composição de lote:
 * sem lote primeiro; já em lote por último.
 */
export function sortAnimalsForLotInclusion<T extends Pick<AnimalSummary, 'lot_id' | 'internal_number' | 'animal_name'>>(
  animals: T[],
): T[] {
  return [...animals].sort((a, b) => {
    const aInLot = a.lot_id != null;
    const bInLot = b.lot_id != null;
    if (aInLot !== bInLot) return aInLot ? 1 : -1;

    const aLabel = `${a.internal_number} ${a.animal_name ?? ''}`.toLowerCase();
    const bLabel = `${b.internal_number} ${b.animal_name ?? ''}`.toLowerCase();
    return aLabel.localeCompare(bLabel, 'pt');
  });
}
